<template>
  <TarjetaDatos :titulo="titulo" tipo="naranja">
      
     Póliza mediada. Póngase en contacto con INTERNAUTO
     
  </TarjetaDatos>
</template>

<script>
export default {
  props: {
    recibo: {
      type: Object,
      required: true
    }
  },
  computed: {
    titulo() {
      if (!this.recibo.idRecibo) return "Cargando datos...";
      let fecha = this.$options.filters.dateDDMMYYYY(
        this.recibo.nsg("fecRecibo")
      );
      return `Recibo de fecha ${fecha}`;
    }
  }
};
</script>

<style lang="scss" scoped></style>
